module.exports = __webpack_public_path__ + "static/media/Create_banner_horizontal.4b876125.png";